<template>

<app-content :loading="is.loading">

	<app-content-body 
        v-if="!is.loading" 
        :is-call="true"
    >

		<app-content-call 
            theme="blue" 
            icon="application.convert" 
            title="Convert Application" 
            text="Manually convert this application into a new or existing badge and preserve any attached game submissions." 
            button="Confirm" 
            :loading="is.confirming" 
            :has-cancel="true" 
            :disabled="!isValid"
            v-on:click="onConfirmClick" 
            v-on:cancel="onCancelClick"
        >

            <div class="form">

                <app-input-toggle 
                    :options="existOptions"
                    :full-width="true"
                    v-model="model.exist" 
                />

                <template v-if="model.exist">

                <app-input-suggest 
                    placeholder="Search badges..." 
                    v-model="model.badge" 
                    api="convention/badge" 
                    :validation="$v.model.badge" 
                />

                </template>

                <template v-if="!model.exist">

                <app-input-account 
                    type="badge" 
                    :text="emailMessages" 
                    v-model="model.email" 
                    v-on:exists="onExistsChange" 
                    :validation="$v.model.email" 
                />
                
                <app-input-text 
                    v-model="model.firstname" 
                    :validation="$v.model.firstname" 
                    placeholder="Enter first name" 
                    :maxlength="32" 
                />
                
                <app-input-text 
                    v-model="model.lastname" 
                    :validation="$v.model.lastname" 
                    placeholder="Enter last name" 
                    :maxlength="32" 
                />
                
                <app-input-select 
                    v-model="model.type" 
                    :validation="$v.model.type" 
                    placeholder="Select badge type" 
                    :options="$util.options(references.types, 'name', 'id')" 
                    v-if="$permissions.badges.types.enabled && references.types.length" 
                />

                </template>

            </div>

        </app-content-call>
	
	</app-content-body>

</app-content>

</template>

<script>

import Vue from 'vue'
import { requiredIf, maxLength, minLength, email } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate';

export default {

	mixins: [validationMixin],

	data: function() {

		return {
			is: {
				loading: true,
				confirming: false
			},
            references: {
                types: []
            },
            existOptions: {
                0: 'New badge',
                1: 'Existing badge'
            },
            model: {
                exist: 0,
                badge: '',
				firstname: '',
				lastname: '',
				email: '',
				type: 0
            },
            emailMessages: {
				info: 'The e-mail address used must not already be associated with an existing badge for this convention.',
				added: 'This e-mail address is already associated with a badge.',
				exists: 'This e-mail address is already associated with an existing Cardboard Events account but they do not have a badge.',
				register: 'A Cardboard Events login will be generated for this e-mail address and will be associated with their badge. The login credentials will automatically be e-mailed to the user.'
			},
			application: {},
            used: false
		}

	},

	validations: {
		model: {
			firstname: {
				requiredIf: requiredIf(function() {

					return !this.model.exist

				}),
				maxLength: maxLength(32)
			},
			lastname: {
				requiredIf: requiredIf(function() {

					return !this.model.exist

				}),
				maxLength: maxLength(32)
			},
			type: {
				requiredIf: requiredIf(function() {

					return !this.model.exist && this.references.types.length

				}),
				minLength: function(value, model) {
                
                    return (model.exist) ? true : minLength(8)(value)
                
                }
			},
			email: {
				requiredIf: requiredIf(function() {

					return !this.model.exist

				}),
				email
			},
			badge: {
				requiredIf: requiredIf(function() {

					return this.model.exist

				}),
				minLength: function(value, model) {
                
                    return (!model.exist) ? true : minLength(8)(value)
                
                }
			}
		}
	},

	created: function() {

		this.load();

	},

    computed: {
    
        isValid: function() {

			return !this.$v.$invalid && (!this.used || this.model.exist)

		}

    },

	methods: {

        onExistsChange: function(e) {

			this.used = e.used

		},

		onCancelClick: function() {

			this.$router.push({
				name: 'Convention.Registration.Applications.Edit'
			})

		},

		onConfirmClick: async function() {

			this.is.confirming = true

			this.$api.post('convention/registration/application/' + this.$route.params.id + '/convert', this.model).then(function() {
            
                this.$notify({
					message: 'The application has been converted.'
				})

				this.$router.push({
                    name: 'Convention.Registration.Applications.Edit'
				})

            }.bind(this))

		},

		load: function() {

			this.$api.get('convention/registration/application/' + this.$route.params.id + '/convert').then(function(response) {

				Vue.set(this, 'application', response.application)
                Vue.set(this.references, 'types', response.types)

				this.is.loading = false

			}.bind(this), function() {
            
                this.$notify({
					message: 'This is not a valid application.',
					type: 'error'
				})

				this.$router.push({
                    name: 'Convention.Registration.Applications.Edit'
				})
            
            }.bind(this))

		}

	}

}

</script>

<style scoped>

.form {
    display: flex;
    flex-direction: column;
    margin-top: 40px;
    width: 100%;
}

.form >>> .input {
    width: 100%;
}

</style>
